module.exports = __webpack_public_path__ + "img/form-shape.7a78b0a8.svg";